import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TeamProps } from '../../EventTypes'
import LabelFont from '../../../../Theme/Fonts/Label'
import TeamImage from '../../../../BaseComponents/Image/Team'

type TeamInfo = {
    teamProps: TeamProps
}

export const TeamInfoDisplay: FunctionComponent<TeamInfo> = ({ teamProps }) => {
    return (
        <Grid horizontal centerVertical>
            <Grid noExpand marginRight={3}>
                <TeamImage size="S" width={16} imageUrl={teamProps?.teamImage} />
            </Grid>
            <Grid>
                <LabelFont numberOfLines={1} color="keshi-3">
                    {teamProps?.teamName}
                </LabelFont>
            </Grid>
        </Grid>
    )
}
